/* node_modules/.pnpm/svelte-bricks@0.2.1/node_modules/svelte-bricks/dist/Masonry.svelte generated by Svelte v4.2.19 */
import { SvelteComponent, add_iframe_resize_listener, add_render_callback, add_transform, append, attr, check_outros, create_animation, create_in_transition, create_out_transition, create_slot, destroy_each, detach, element, empty, ensure_array_like, fix_and_outro_and_destroy_block, fix_position, get_all_dirty_from_scope, get_slot_changes, group_outros, init, insert, noop, outro_and_destroy_block, safe_not_equal, set_data, set_style, space, text, transition_in, transition_out, update_keyed_each, update_slot_base } from "svelte/internal";
import "svelte/internal/disclose-version";
import { flip } from 'svelte/animate';
import { fade } from 'svelte/transition';
function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[18] = list[i];
  return child_ctx;
}
function get_each_context_2(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[21] = list[i][0];
  child_ctx[22] = list[i][1];
  return child_ctx;
}
const get_default_slot_changes_1 = dirty => ({
  idx: dirty & /*itemsToCols*/1024,
  item: dirty & /*itemsToCols*/1024
});
const get_default_slot_context_1 = ctx => ({
  idx: /*idx*/ctx[22],
  item: /*item*/ctx[21]
});
function get_each_context_1(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[21] = list[i][0];
  child_ctx[22] = list[i][1];
  return child_ctx;
}
const get_default_slot_changes = dirty => ({
  idx: dirty & /*itemsToCols*/1024,
  item: dirty & /*itemsToCols*/1024
});
const get_default_slot_context = ctx => ({
  idx: /*idx*/ctx[22],
  item: /*item*/ctx[21]
});

// (67:6) {:else}
function create_else_block(ctx) {
  let each_blocks = [];
  let each_1_lookup = new Map();
  let each_1_anchor;
  let current;
  let each_value_2 = ensure_array_like(/*col*/ctx[18]);
  const get_key = ctx => /*getId*/ctx[6](/*item*/ctx[21]);
  for (let i = 0; i < each_value_2.length; i += 1) {
    let child_ctx = get_each_context_2(ctx, each_value_2, i);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i] = create_each_block_2(key, child_ctx));
  }
  return {
    c() {
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(target, anchor);
        }
      }
      insert(target, each_1_anchor, anchor);
      current = true;
    },
    p(ctx, dirty) {
      if (dirty & /*itemsToCols, $$scope, getId*/33856) {
        each_value_2 = ensure_array_like(/*col*/ctx[18]);
        group_outros();
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value_2, each_1_lookup, each_1_anchor.parentNode, outro_and_destroy_block, create_each_block_2, each_1_anchor, get_each_context_2);
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      for (let i = 0; i < each_value_2.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(each_1_anchor);
      }
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].d(detaching);
      }
    }
  };
}

// (55:6) {#if animate}
function create_if_block(ctx) {
  let each_blocks = [];
  let each_1_lookup = new Map();
  let each_1_anchor;
  let current;
  let each_value_1 = ensure_array_like(/*col*/ctx[18]);
  const get_key = ctx => /*getId*/ctx[6](/*item*/ctx[21]);
  for (let i = 0; i < each_value_1.length; i += 1) {
    let child_ctx = get_each_context_1(ctx, each_value_1, i);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i] = create_each_block_1(key, child_ctx));
  }
  return {
    c() {
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(target, anchor);
        }
      }
      insert(target, each_1_anchor, anchor);
      current = true;
    },
    p(ctx, dirty) {
      if (dirty & /*duration, itemsToCols, $$scope, getId*/33872) {
        each_value_1 = ensure_array_like(/*col*/ctx[18]);
        group_outros();
        for (let i = 0; i < each_blocks.length; i += 1) each_blocks[i].r();
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value_1, each_1_lookup, each_1_anchor.parentNode, fix_and_outro_and_destroy_block, create_each_block_1, each_1_anchor, get_each_context_1);
        for (let i = 0; i < each_blocks.length; i += 1) each_blocks[i].a();
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      for (let i = 0; i < each_value_1.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(each_1_anchor);
      }
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].d(detaching);
      }
    }
  };
}

// (69:29)              
function fallback_block_1(ctx) {
  let span;
  let t0_value = /*item*/ctx[21] + "";
  let t0;
  let t1;
  return {
    c() {
      span = element("span");
      t0 = text(t0_value);
      t1 = space();
      attr(span, "class", "svelte-b2jtby");
    },
    m(target, anchor) {
      insert(target, span, anchor);
      append(span, t0);
      insert(target, t1, anchor);
    },
    p(ctx, dirty) {
      if (dirty & /*itemsToCols*/1024 && t0_value !== (t0_value = /*item*/ctx[21] + "")) set_data(t0, t0_value);
    },
    d(detaching) {
      if (detaching) {
        detach(span);
        detach(t1);
      }
    }
  };
}

// (68:8) {#each col as [item, idx] (getId(item))}
function create_each_block_2(key_1, ctx) {
  let first;
  let current;
  const default_slot_template = /*#slots*/ctx[16].default;
  const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ctx[15], get_default_slot_context_1);
  const default_slot_or_fallback = default_slot || fallback_block_1(ctx);
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      if (default_slot_or_fallback) default_slot_or_fallback.c();
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      if (default_slot_or_fallback) {
        default_slot_or_fallback.m(target, anchor);
      }
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope, itemsToCols*/33792)) {
          update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ctx[15], !current ? get_all_dirty_from_scope(/*$$scope*/ctx[15]) : get_slot_changes(default_slot_template, /*$$scope*/ctx[15], dirty, get_default_slot_changes_1), get_default_slot_context_1);
        }
      } else {
        if (default_slot_or_fallback && default_slot_or_fallback.p && (!current || dirty & /*itemsToCols*/1024)) {
          default_slot_or_fallback.p(ctx, !current ? -1 : dirty);
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot_or_fallback, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot_or_fallback, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(first);
      }
      if (default_slot_or_fallback) default_slot_or_fallback.d(detaching);
    }
  };
}

// (62:31)                
function fallback_block(ctx) {
  let span;
  let t_value = /*item*/ctx[21] + "";
  let t;
  return {
    c() {
      span = element("span");
      t = text(t_value);
      attr(span, "class", "svelte-b2jtby");
    },
    m(target, anchor) {
      insert(target, span, anchor);
      append(span, t);
    },
    p(ctx, dirty) {
      if (dirty & /*itemsToCols*/1024 && t_value !== (t_value = /*item*/ctx[21] + "")) set_data(t, t_value);
    },
    d(detaching) {
      if (detaching) {
        detach(span);
      }
    }
  };
}

// (56:8) {#each col as [item, idx] (getId(item))}
function create_each_block_1(key_1, ctx) {
  let div;
  let t;
  let div_intro;
  let div_outro;
  let rect;
  let stop_animation = noop;
  let current;
  const default_slot_template = /*#slots*/ctx[16].default;
  const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ctx[15], get_default_slot_context);
  const default_slot_or_fallback = default_slot || fallback_block(ctx);
  return {
    key: key_1,
    first: null,
    c() {
      div = element("div");
      if (default_slot_or_fallback) default_slot_or_fallback.c();
      t = space();
      attr(div, "class", "svelte-b2jtby");
      this.first = div;
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if (default_slot_or_fallback) {
        default_slot_or_fallback.m(div, null);
      }
      append(div, t);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope, itemsToCols*/33792)) {
          update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ctx[15], !current ? get_all_dirty_from_scope(/*$$scope*/ctx[15]) : get_slot_changes(default_slot_template, /*$$scope*/ctx[15], dirty, get_default_slot_changes), get_default_slot_context);
        }
      } else {
        if (default_slot_or_fallback && default_slot_or_fallback.p && (!current || dirty & /*itemsToCols*/1024)) {
          default_slot_or_fallback.p(ctx, !current ? -1 : dirty);
        }
      }
    },
    r() {
      rect = div.getBoundingClientRect();
    },
    f() {
      fix_position(div);
      stop_animation();
      add_transform(div, rect);
    },
    a() {
      stop_animation();
      stop_animation = create_animation(div, rect, flip, {
        duration: /*duration*/ctx[4]
      });
    },
    i(local) {
      if (current) return;
      transition_in(default_slot_or_fallback, local);
      if (local) {
        add_render_callback(() => {
          if (!current) return;
          if (div_outro) div_outro.end(1);
          div_intro = create_in_transition(div, fade, {
            delay: 100,
            duration: /*duration*/ctx[4]
          });
          div_intro.start();
        });
      }
      current = true;
    },
    o(local) {
      transition_out(default_slot_or_fallback, local);
      if (div_intro) div_intro.invalidate();
      if (local) {
        div_outro = create_out_transition(div, fade, {
          delay: 0,
          duration: /*duration*/ctx[4]
        });
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(div);
      }
      if (default_slot_or_fallback) default_slot_or_fallback.d(detaching);
      if (detaching && div_outro) div_outro.end();
    }
  };
}

// (53:2) {#each itemsToCols as col}
function create_each_block(ctx) {
  let div;
  let current_block_type_index;
  let if_block;
  let t;
  let div_class_value;
  let current;
  const if_block_creators = [create_if_block, create_else_block];
  const if_blocks = [];
  function select_block_type(ctx, dirty) {
    if (/*animate*/ctx[2]) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx, -1);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      div = element("div");
      if_block.c();
      t = space();
      attr(div, "class", div_class_value = "col " + /*columnClass*/ctx[3] + " svelte-b2jtby");
      set_style(div, "gap", /*gap*/ctx[5] + "px");
      set_style(div, "max-width", /*maxColWidth*/ctx[7] + "px");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if_blocks[current_block_type_index].m(div, null);
      append(div, t);
      current = true;
    },
    p(ctx, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx, dirty);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block.c();
        } else {
          if_block.p(ctx, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(div, t);
      }
      if (!current || dirty & /*columnClass*/8 && div_class_value !== (div_class_value = "col " + /*columnClass*/ctx[3] + " svelte-b2jtby")) {
        attr(div, "class", div_class_value);
      }
      if (!current || dirty & /*gap*/32) {
        set_style(div, "gap", /*gap*/ctx[5] + "px");
      }
      if (!current || dirty & /*maxColWidth*/128) {
        set_style(div, "max-width", /*maxColWidth*/ctx[7] + "px");
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(div);
      }
      if_blocks[current_block_type_index].d();
    }
  };
}
function create_fragment(ctx) {
  let div;
  let div_class_value;
  let div_style_value;
  let div_resize_listener;
  let current;
  let each_value = ensure_array_like(/*itemsToCols*/ctx[10]);
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  const out = i => transition_out(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  return {
    c() {
      div = element("div");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(div, "class", div_class_value = "masonry " + /*className*/ctx[9] + " svelte-b2jtby");
      attr(div, "style", div_style_value = "gap: " + /*gap*/ctx[5] + "px; " + /*style*/ctx[8]);
      add_render_callback(() => /*div_elementresize_handler*/ctx[17].call(div));
    },
    m(target, anchor) {
      insert(target, div, anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div, null);
        }
      }
      div_resize_listener = add_iframe_resize_listener(div, /*div_elementresize_handler*/ctx[17].bind(div));
      current = true;
    },
    p(ctx, [dirty]) {
      if (dirty & /*columnClass, gap, maxColWidth, itemsToCols, duration, $$scope, animate*/33980) {
        each_value = ensure_array_like(/*itemsToCols*/ctx[10]);
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(div, null);
          }
        }
        group_outros();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
      if (!current || dirty & /*className*/512 && div_class_value !== (div_class_value = "masonry " + /*className*/ctx[9] + " svelte-b2jtby")) {
        attr(div, "class", div_class_value);
      }
      if (!current || dirty & /*gap, style*/288 && div_style_value !== (div_style_value = "gap: " + /*gap*/ctx[5] + "px; " + /*style*/ctx[8])) {
        attr(div, "style", div_style_value);
      }
    },
    i(local) {
      if (current) return;
      for (let i = 0; i < each_value.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(div);
      }
      destroy_each(each_blocks, detaching);
      div_resize_listener();
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let nCols;
  let itemsToCols;
  let {
    $$slots: slots = {},
    $$scope
  } = $$props;
  let {
    animate = true
  } = $$props;
  let {
    columnClass = ``
  } = $$props;
  let {
    duration = 200
  } = $$props;
  let {
    gap = 20
  } = $$props;
  let {
    getId = item => {
      if (typeof item === `number`) return item;
      if (typeof item === `string`) return item;
      return item[idKey];
    }
  } = $$props;
  let {
    idKey = `id`
  } = $$props;
  let {
    items
  } = $$props;
  let {
    masonryHeight = 0
  } = $$props;
  let {
    masonryWidth = 0
  } = $$props;
  let {
    maxColWidth = 500
  } = $$props;
  let {
    minColWidth = 330
  } = $$props;
  let {
    style = ``
  } = $$props;
  let {
    class: className = ``
  } = $$props;
  function div_elementresize_handler() {
    masonryWidth = this.clientWidth;
    masonryHeight = this.clientHeight;
    $$invalidate(0, masonryWidth);
    $$invalidate(1, masonryHeight);
  }
  $$self.$$set = $$props => {
    if ('animate' in $$props) $$invalidate(2, animate = $$props.animate);
    if ('columnClass' in $$props) $$invalidate(3, columnClass = $$props.columnClass);
    if ('duration' in $$props) $$invalidate(4, duration = $$props.duration);
    if ('gap' in $$props) $$invalidate(5, gap = $$props.gap);
    if ('getId' in $$props) $$invalidate(6, getId = $$props.getId);
    if ('idKey' in $$props) $$invalidate(11, idKey = $$props.idKey);
    if ('items' in $$props) $$invalidate(12, items = $$props.items);
    if ('masonryHeight' in $$props) $$invalidate(1, masonryHeight = $$props.masonryHeight);
    if ('masonryWidth' in $$props) $$invalidate(0, masonryWidth = $$props.masonryWidth);
    if ('maxColWidth' in $$props) $$invalidate(7, maxColWidth = $$props.maxColWidth);
    if ('minColWidth' in $$props) $$invalidate(13, minColWidth = $$props.minColWidth);
    if ('style' in $$props) $$invalidate(8, style = $$props.style);
    if ('class' in $$props) $$invalidate(9, className = $$props.class);
    if ('$$scope' in $$props) $$invalidate(15, $$scope = $$props.$$scope);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*items, masonryWidth, minColWidth, gap*/12321) {
      $: $$invalidate(14, nCols = Math.min(items.length, Math.floor(masonryWidth / (minColWidth + gap)) || 1));
    }
    if ($$self.$$.dirty & /*items, nCols*/20480) {
      $: $$invalidate(10, itemsToCols = items.reduce((cols, item, idx) => {
        cols[idx % cols.length].push([item, idx]);
        return cols;
      }, Array(nCols).fill(null).map(() => []) // prettier-ignore
      ));
    }
  };
  return [masonryWidth, masonryHeight, animate, columnClass, duration, gap, getId, maxColWidth, style, className, itemsToCols, idKey, items, minColWidth, nCols, $$scope, slots, div_elementresize_handler];
}
class Masonry extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance, create_fragment, safe_not_equal, {
      animate: 2,
      columnClass: 3,
      duration: 4,
      gap: 5,
      getId: 6,
      idKey: 11,
      items: 12,
      masonryHeight: 1,
      masonryWidth: 0,
      maxColWidth: 7,
      minColWidth: 13,
      style: 8,
      class: 9
    });
  }
}
export default Masonry;
import '/home/maxlath/code/inventaire/inventaire/client/node_modules/.pnpm/svelte-bricks@0.2.1/node_modules/svelte-bricks/dist/Masonry.svelte.189.css!=!svelte-loader?cssPath=/home/maxlath/code/inventaire/inventaire/client/node_modules/.pnpm/svelte-bricks@0.2.1/node_modules/svelte-bricks/dist/Masonry.svelte.189.css!/home/maxlath/code/inventaire/inventaire/client/node_modules/.pnpm/svelte-bricks@0.2.1/node_modules/svelte-bricks/dist/Masonry.svelte';